import { useAppSelector } from "store"
import { NodeTypes } from "@cloudike/web_files"
import { createSelector } from "@reduxjs/toolkit"

import { folderSelectionModalSelectors } from "./folderSelectionModalSlice"

const getFolderSelectionModallNodesRawSelector = state => folderSelectionModalSelectors.selectAll(state.folderSelectionModal)

export const getFolderSelectionModalNodesSelector = () => useAppSelector(
  createSelector(
    getFolderSelectionModallNodesRawSelector,
    items =>
      items.filter(node => node.type === NodeTypes.DIR)
  ))

export const getFolderSelectionModalBreadcrumbsSelector = () => useAppSelector(state => state.folderSelectionModal.breadcrumbs)

export const getFolderSelectionModalStatusSelector = () => useAppSelector(state => state.folderSelectionModal.status)
